import { ItemType } from '@frontend/sports/common/core/data-access/sport-model';

import { BaseTreeItem } from '../../../../competition-list/competition-list.models';

export class MeetingTreeTtem extends BaseTreeItem {
    constructor(title: string, id: number[], type: ItemType, children: BaseTreeItem[], expand: boolean) {
        super();
        this.id = id[0];
        this.regions = ItemType.Region && id?.length > 1 ? id : [];
        this.title = title;
        this.icon = type === ItemType.Region && id?.length === 1 ? `country-icon c${this.id}` : '';
        this.attribute = {
            id: this.id,
            type: type ? type : 'event',
        };
        this.expanded = true;
        this.active = true;
        this.children = children;
        this.count = children.reduce((sum, x) => sum + (x.count ?? 0), 0);
    }
}
